import React from 'react';
import PropTypes from 'prop-types';

class Panel extends React.Component {
    constructor(props) {
        super(props);
        this.displayName = 'Panel';
        this.state = {
            displayToggle : false,
            fixHeight : false
        }
    }

    componentWillReceiveProps() {
        var _self = this;

        if (typeof _self.props.displayToggle !== 'undefined') {
            var displayToggle = (_self.props.displayToggle == true)? true : false;
            _self.setState({displayToggle : displayToggle});
        }
        if (typeof _self.props.fixHeight !== 'undefined') {
            var fixHeight = (_self.props.fixHeight == true)? true : false;
            _self.setState({fixHeight : fixHeight});
        }
    }

    render() {

        var _self = this;
        var className = typeof this.props.className !== 'undefined'? this.props.className:'';
        var divStyle = {
          height: 636,
          "overflowY": 'scroll'
        };

        return(
			<section className={"panel " + className}>
        		<header className="panel-heading">

                    {(()=> {
                        if (_self.state.displayToggle) {
                            return (
                                <div>
                                <h2 className="col-xs-11 panel-title">{this.props.title}</h2>
                                <a href="#" className="panel-action panel-action-toggle" data-panel-toggle></a>
                                </div>
                                );
                        }
                        else {
                            return (
                                <h2 className="panel-title">{this.props.title}</h2>
                                );
                        }
                    }) ()}

        		</header>

                {(()=> {
                    if (_self.state.fixHeight) {
                        return (
                            <div className="panel-body" style={divStyle}>
                                {_self.props.children}
                            </div>
                            );
                    }
                    else {
                        return (
                            <div className="panel-body">
                                {_self.props.children}
                            </div>
                            );
                    }
                }) ()}

        	</section>
        );
    }
}

export default Panel;



// WEBPACK FOOTER //
// ./src/browser/components/ui/panel.js